/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Group from 'material/group/group';
import DropDownIndicator from 'material/dropdowns/dropfilter/dropdownindicator/dropdownindicator';
import DropDownItem from 'material/dropdowns/dropfilter/dropdownitem/dropdownitem';
import Button from 'material/ctas/button/button';
import SearchBar from 'material/searchbar/searchbar';
import Icon from 'material/graphic/icon/icon';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/dropdowns/dropfilter/dropfilter_styles';



/* ========== ~~~~~~~~~~ DROP FILTER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class DropFilter extends Component {
	constructor(props) {
		super(props);
	  this.state = { active: false, searchTerm: '', items: this.props.items };
	  this.controls = this.props.items.length > 10;
	  this.filterAvailable = false;
    }

  componentDidMount() {
    return document.addEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    return document.removeEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentDidUpdate(prevProps){
	    if(this.props.items.length !== prevProps.items.length){
            this.controls = this.props.items.length > 10;
            this.setState({items:this.props.items});
        }
  }

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) { return; }
    if(this.state.active)this.hideMenu();
  };


  hideMenu = () => this.setState({ active: false });

  renderItems = ()=>{
    return  this.state.items.map((item, i)=>{
          return <DropDownItem handleSelect={this.handleSelect} handleDeselect={this.handleDeselect} searchTerm={this.state.searchTerm} itemSelected={this.props.selectedItems.indexOf(item.value) >= 0} key={i} index={i} value={item.value} item={item.name} />
      })
  };

  renderControls = ()=>{
     return this.controls ?  <div><SearchBar value={this.state.searchTerm} onChange={this.handleSearch} />
          <div onClick={this.handleSelectAll} className={`all-items`} > <Icon name={`plus-circle`} /> Select all</div>
      <div onClick={this.handleSelectNone} className={`all-items`} > <Icon name={`times-circle`}/> Select none</div></div> :
          null;
  };

  onSelect = (items) =>{
      this.props.onSelect(items);
      this.filterAvailable = true;
  }

  handleSelect = item =>{
     let items = [...this.props.selectedItems, item];
     this.onSelect(items);
  };

  handleDeselect = item =>{
    let  items = [...this.props.selectedItems];
    items.splice(items.indexOf(item),1);
    this.onSelect(items);
  };

  handleFilterClick = ()=>{
      this.props.buttonAction(this.props.selectedItems) ;
      this.setState({active:false});
      this.filterAvailable = false;
  };

  handleIndicatorClick = (e) => this.setState({ active: !this.state.active});

  handleSearch = (keywords)=>{
    let initialItems = this.props.items.map(item=>item.name.toLowerCase());
    let filteredItems = initialItems.filter(item=>item.indexOf(keywords.toLowerCase()) >= 0);

    let items = this.props.items.filter(item=>filteredItems.indexOf(item.name.toLowerCase()) >= 0);
    this.setState({items: items, searchTerm:keywords});
  };

  handleSelectAll = ()=>{
      let items = this.props.items.map(item=>item.value);
      this.setState({searchTerm: '', items: this.props.items});
      this.onSelect(items);
  };

  handleSelectNone = ()=>{
      this.onSelect([]);
  };

	render() {
        let {title, name} = this.props;
        let {active} = this.state;
		return (
	        <div className={`dropdownfilter ${this.props.classes.dropdownfilter} filter ${generateClasses(this.props)} disabled-${this.props.disabled}`} ref={node => {this.node=node;}}>
	        	<DropDownIndicator active={active} title={title} name={name} selected={this.props.selectedItems.length} icon={this.props.icon} toggleMenu={this.handleIndicatorClick} />
            <Group name={`menuItems active-${this.state.active}`}  >
                <Group>
                    {this.renderControls()}
                    <div className={this.controls ? `items` : null} >
                        {this.renderItems()}
                    </div>
                </Group>
                {this.props.button !== `false` && <Button handleClick={this.handleFilterClick} variant={this.filterAvailable ? `primary` : `disabled` } name={`filter`} text={`Filter`} />}
            </Group>
	        </div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DropFilter);